'use client';
import { Button } from '@pickleballinc/react-ui';
import { useEffect } from 'react';

import { useLoader } from '@/modules/league/PickleballLoaderContext';
import { useRouter, useSearchParams } from 'next/navigation';

export const NavLink = ({
  text,
  currentType,
  pageType,
  isStats,
  sequenceNumber,
}: {
  text: string;
  currentType: string;
  pageType: string | undefined;
  isStats: boolean;
  sequenceNumber: string | null;
}) => {
  const formattedText =
    currentType === 'rsvp' ? text.toUpperCase() : text.charAt(0).toUpperCase() + text.slice(1);
  const searchParams = useSearchParams();
  const router = useRouter();
  const isActive = pageType === currentType;
  const { setLoading } = useLoader();
  useEffect(() => {
    setLoading(false);
  }, [pageType]);

  const handleClick = () => {
    if (!isActive) {
      setLoading(true);
      const newSearchParams = new URLSearchParams(searchParams || '');
      newSearchParams.set('tab', currentType);
      router.replace(`?${newSearchParams.toString()}`, { scroll: false });
      if (sequenceNumber && currentType !== 'rsvp') {
        newSearchParams.set('sequenceNumber', sequenceNumber);
        router.replace(`?${newSearchParams.toString()}`, { scroll: false });
      }
    }
  };

  return (
    <Button
      variant={isActive ? 'primary' : 'secondary'}
      className={`flex w-full max-w-[411.667px] justify-center rounded-lg border border-gray-300 font-semibold !shadow-xs ${
        currentType !== 'rsvp' ? '' : ''
      } ${isActive ? '!bg-leagues-500 !text-white hover:!bg-leagues-300' : '!bg-white !text-gray-700 hover:!bg-gray-100'}`}
      onClick={handleClick}
    >
      {formattedText === 'Groups' && isStats ? 'Stats' : formattedText}
    </Button>
  );
};
